import { dataCouponPercentSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCouponPercentSolid = /*#__PURE__*/createIcon(dataCouponPercentSolid)
export default IconCouponPercentSolid
